module.exports = __webpack_public_path__ + "static/media/tracked.20d29f9c.svg";